import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'
// Redux
import { withRouter } from "react-router-dom"
// actions
import { getQuotations, deleteQuotation, addNewQuotation, updateQuotation, updateQuotationStatus } from "../../../store/catalogs/Quotations/actions"
import { useSelector, useDispatch } from "react-redux";
import PropTypes from 'prop-types'
import { QuotationRegisterModal } from './QuotationRegisterModal';

import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"

const QuotationCatalog = (props) => {

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getQuotations("?limit=20&page=0"))
    }, [])

    const { quotations, loading, total, currentPage } = useSelector(state => ({
        quotations: state.quotationsReducer.quotations,
        loading: state.quotationsReducer.loading,
        quotation: state.quotationsReducer.quotation,
        total: state.quotationsReducer.total,
        currentPage: state.quotationsReducer.currentPage
    }));
    // * Redux fin

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getQuotations(`?limit=20&page=0&search=${searchData}`))
    }, [searchData])

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Nota de Cotización',
                accessor: 'note',
                width: '80%',
            },
            {
                Header: 'Estatus',
                width: '15%',
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateQuotation(updValue))
            dispatch(updateQuotationStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
        } else {
            dispatch(addNewQuotation(values))
        }
        setTimeout(() => {
            dispatch(getQuotations("?limit=20&page=0"))
        }, 500);
        setIsUpdate(false)
        setRowInfo('')
    }

    const modalClose = () => {
        setIsUpdate(false)
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteQuotation(rowInfo))
        setRowInfo('')
    }

    const getPagination = (params) => {
        dispatch(getQuotations(`${params}&search=${searchData}`))
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 50 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='Quotation' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={quotations} />
                                </div>

                                <QuotationRegisterModal
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                    isUpdate={isUpdate}
                                    modalRespInfo={RegisterModalRespInfo}
                                    props={props}
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                    modalHeader='Registro/Actualización de Notas de Cotización'
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar tipo de laboratorio' modalBodyLabel='¿Está seguro que desea eliminar el tipo de laboratorio seleccionado?' />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>

            </div>
        </React.Fragment >
    )
}
export default withRouter(QuotationCatalog)

QuotationCatalog.propTypes = {
    error: PropTypes.any,
    getLabTypes: PropTypes.func,
}